import { render, staticRenderFns } from "./ExportacaoDetalhes.vue?vue&type=template&id=e93b1580&scoped=true"
import script from "./ExportacaoDetalhes.vue?vue&type=script&lang=js"
export * from "./ExportacaoDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ExportacaoDetalhes.vue?vue&type=style&index=0&id=e93b1580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b1580",
  null
  
)

export default component.exports